import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://sf-services.prasmul-eli.co/api',
})

export default instance